import { ConsultantEventLogDataFragment } from "@bonliva-crm/graphql";
import { ConsultantEventType } from "@bonliva-crm/shared";
import { MainFilterType, FilterType, OtherFilterType } from "./filter-type";

export const groupEventsByFilterType = (
  events: ConsultantEventLogDataFragment[]
): Record<FilterType, ConsultantEventLogDataFragment[]> => {
  const groupedEvents: Record<FilterType, ConsultantEventLogDataFragment[]> = {
    [MainFilterType.Call]: [],
    [MainFilterType.Noanswer]: [],
    [MainFilterType.Email]: [],
    [MainFilterType.SMS]: [],
    [MainFilterType.Comment]: [],
    [MainFilterType.Interest]: [],
    [OtherFilterType.GDPR]: [],
    [OtherFilterType.QualityUpdate]: [],
    [OtherFilterType.Reminder]: [],
    [OtherFilterType.Registered]: [],
    [OtherFilterType.SystemLog]: [],
    [OtherFilterType.ConsultantApp]: [],
    [OtherFilterType.WelcomeEmail]: [],
    [OtherFilterType.UserSettings]: []
  };

  // Iterate through the events array once, classifying each event into the appropriate categories.
  events.forEach((event) => {
    // Check the type of each event and classify it accordingly.
    switch (event.Type) {
      case ConsultantEventType.Call:
        groupedEvents[MainFilterType.Call].push(event);
        break;
      case ConsultantEventType.Noanswer:
        groupedEvents[MainFilterType.Noanswer].push(event);
        break;
      case ConsultantEventType.Email:
        groupedEvents[MainFilterType.Email].push(event);
        break;
      case ConsultantEventType.SMS:
        groupedEvents[MainFilterType.SMS].push(event);
        break;
      case ConsultantEventType.Comment:
        groupedEvents[MainFilterType.Comment].push(event);
        break;
      case ConsultantEventType.Interest:
        groupedEvents[MainFilterType.Interest].push(event);
        break;
      case ConsultantEventType.GDPR:
        groupedEvents[OtherFilterType.GDPR].push(event);
        break;
      case ConsultantEventType.QualityUpdate:
        groupedEvents[OtherFilterType.QualityUpdate].push(event);
        break;
      case ConsultantEventType.Reminder:
        groupedEvents[OtherFilterType.Reminder].push(event);
        break;
      case ConsultantEventType.Registered:
        groupedEvents[OtherFilterType.Registered].push(event);
        break;
      case ConsultantEventType.SystemLog:
        groupedEvents[OtherFilterType.SystemLog].push(event);
        break;
      case ConsultantEventType.ConsultantApp:
        groupedEvents[OtherFilterType.ConsultantApp].push(event);
        break;
      case ConsultantEventType.WelcomeEmail:
        groupedEvents[OtherFilterType.WelcomeEmail].push(event);
        break;
      case ConsultantEventType.UserSettings:
        groupedEvents[OtherFilterType.UserSettings].push(event);
        break;
      case ConsultantEventType.MetInPerson:
        groupedEvents[MainFilterType.Call].push(event);
        break;
      case ConsultantEventType.Document:
        groupedEvents[OtherFilterType.SystemLog].push(event);
        break;
      default:
        groupedEvents[OtherFilterType.SystemLog].push(event);
    }
  });

  return groupedEvents;
};
